import React, { useContext, useEffect, useState } from 'react';
import { Editor } from 'primereact/editor';
import { ToastContext } from 'app/context/ToastContext';
import { getDocument, saveDocumentInfo } from 'app/api/documentInfoApi';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';

const DocumentInfo = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [loading, setLoading] = useState(true);
  const [documentInfo, setDocumentInfo] = useState(null);

  useEffect(() => {
    getDocument()
      .then(response => {
        setDocumentInfo(response.data);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  }, []);

  const onSave = () => {
    setLoading(true);

    saveDocumentInfo(documentInfo)
      .then(response => {
        showSuccess('Úspech', 'Text úspešne uložený.');
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const renderEditorHeader = () => {
    return (
      <span className="ql-formats">
        <button className="ql-header ql-picker"></button>
        <button className="ql-bold" aria-label="Bold"></button>
        <button className="ql-italic" aria-label="Italic"></button>
        <button className="ql-underline" aria-label="Underline"></button>
        <button className="ql-list" value="ordered" aria-label="Ordered list"></button>
        <button className="ql-align ql-picker ql-icon-picker ql-expanded" value="ordered" aria-label="Ordered list"></button>
        <button className="ql-link" value="ordered" aria-label="Insert link"></button>
      </span>
    );
  };

  const editorHeader = renderEditorHeader();

  return (
    <div className="card">
      {loading && (
        <div className="flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}
      {!loading && (
        <>
          <h5>Tento text sa zobrazí na úvodnej stránke</h5>
          <Editor
            style={{ height: '250px' }}
            className="mt-3"
            value={documentInfo?.text}
            headerTemplate={editorHeader}
            onTextChange={e =>
              setDocumentInfo(prevState => ({
                ...prevState,
                text: e.htmlValue ?? '',
              }))
            }
          ></Editor>
          <Button type="button" label="Uložiť text" className="p-button-secondary mt-5" onClick={onSave}></Button>
        </>
      )}
    </div>
  );
};

export default DocumentInfo;
